import { TableColumns } from "components/ui/Table";

export const AttributeColumns: TableColumns[] = [
  { Header: "Attribute Name", accessor: "name" },
];
